export const partner_access_links: { [x: string]: string } = {
  e3flix: 'https://e3flixempresas.com.br/#/login',
  'trillio-academy': 'https://trillio.app/education-journey/login',
  iped: 'https://www.iped.com.br/login',
  envipro: 'https://envipro.com.br',
  aprendeai: 'https://aprendeai.com/conta/',
  rocketseat: 'https://app.rocketseat.com.br/signup',
  'fluency-academy': 'https://cursos.fluencyacademy.io/login',
}
